<template>
  <div v-if="img_start_ready">
    <div v-if="show_input_fields">
      <dialog open style="margin-top: 370px">
        Name
        <input
            size="15"
            type="text"
            class="input__lg"
            id="name"
            v-model="full_name"
            name="name"
        />
        <br>
        Phone#
        <input
            size="15"
            type="text"
            class="input__lg"
            id="phone"
            v-model="phone"
            @blur="scrollToTop()"
            name="phone"
        />

        <div v-if="spin_wheel_button_ready">
          <button @click="spin_the_wheel" class="btn btn__primary btn__lg red_button">Spin The Wheel</button>
        </div>

        <div v-if="error_msg_line1">
          {{error_msg_line1}}<br>{{error_msg_line2}}
        </div>

      </dialog>

    </div>

    <!-- video must be loaded hidden first till spin wheel is clicked otherwise empty on iOS-->
    <!--poster="@/assets/logo.png" within <video>-->

      <div v-if="video_is_ready">

        <div v-show="run_video_play">
          <video
              preload="auto"
              playsinline
              ref="winner_video_loaded"
              width="100%">
            <source :src=winner_video_mp4 type="video/mp4">
          </video>
        </div>

        <div v-show="!run_video_play">
          <img :src=img_start_jpg width="100%"/>
        </div>

      </div>
      <div v-else>
<!--        Video not loaded yet ready-->
        <img :src=img_start_jpg width="100%"/>
      </div>

  </div>
  <div v-else>
    <splashScreen></splashScreen>
  </div>

</template>


<script>
import * as api from '@/api'

import splashScreen from '../components/splashScreen';

export default {
  name: 'WheelPage',
  components: {
    splashScreen
  },
  data() {
    return {
      full_name: '',
      phone: '',
      error_msg_line1: '',
      error_msg_line2: '',
      spin_response: [],
      showPriceTimer: null,
      img_start_jpg: null,
      img_start_ready: false,
      img_end_jpg: null,
      img_end_ready: false,
      winner_video_mp4: null,
      video_is_ready: false,
      video_length_secs: null,
      my_var: null,
      run_video_play: false,
      show_input_fields: false,
      show_good_luck: false,
      spin_wheel_button_ready: false,
    };
  },
  props: {
    code: null,
    valid: null,
    id_number: null,
    img_start: null,
    img_end: null,
    winner_video_code: null,
  },
  mounted() {
    this.load_graphics();
  },
  watch: {
    full_name: async function() {
      this.check_spin_wheel_ready();
    },
    phone: async function() {
      this.check_spin_wheel_ready();
    },
    video_is_ready: async function() {
      this.check_spin_wheel_ready();
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0,0);
    },
    check_spin_wheel_ready () {
      let name_phone_ok = this.full_name.length >= 2 && this.phone.match(/\d/g).length===10;

      this.spin_wheel_button_ready = name_phone_ok && this.video_is_ready;
      if(name_phone_ok) {
        this.error_msg_line1 = '';
        this.error_msg_line2 = '';
        if(!this.video_is_ready) {
          this.error_msg_line1 = 'Please wait ...';
          this.error_msg_line2 = '';
        }
      } else {
        this.error_msg_line1 = "Please enter your name and"
        this.error_msg_line2 = "phone number.";
      }
    },
    load_graphics() {
      api.getWinnerVideo({vcode: this.img_start}).then(data => {
        this.img_start_jpg   = data.data;
        this.img_start_ready = true;
        if(this.img_start_jpg.length > 1000) {
          this.show_input_fields = true;
        }
      })
      api.getWinnerVideo({vcode: this.winner_video_code}).then(data => {
        this.winner_video_mp4 = data.data;
        this.video_is_ready   = true;
      })
      api.getWinnerVideo({vcode: this.img_end}).then(data => {
        this.img_end_jpg   = data.data;
        this.img_end_ready = true;
      })
    },
    spin_the_wheel () {
      this.scrollToTop();

      this.play_video();

      this.show_input_fields = false;
      this.show_good_luck    = true;
      this.run_video_play    = true;

      // Start timer to show price won screen, based on video length finishing.
      this.video_length_secs = this.$refs.winner_video_loaded.duration;
      if(this.video_length_secs < 1.00) {
        this.video_length_secs = 8.50;
      }
      this.showPriceTimer = setInterval(function () {
        clearInterval(this.showPriceTimer);

        this.run_video_play = false;
        this.show_good_luck = false;

        this.$router.push({name: "WinnerPage", 'params': {full_name: this.full_name, winner_image:this.img_end_jpg, win_dollar: this.spin_response.wincode}});

      }.bind(this), (this.video_length_secs * 1000) + 300);

      api.spinTheWheel({code: this.code, name: this.full_name, phone: this.phone}).then(data => {
        this.spin_response = data.data;
      })
    },
    play_video() {
      this.$refs.winner_video_loaded.play();
      // https://jsfiddle.net/johandalabacka/be3qo6w8/
      // https://forum.vuejs.org/t/how-can-i-bind-video-tag-method-to-play-stop-video/79285
      // https://stackoverflow.com/questions/34165653/using-video-js-to-play-video-inline-on-ios#43617296
      // https://webkit.org/blog/6784/new-video-policies-for-ios/
      // https://www.w3schools.com/jsref/dom_obj_video.asp
      //   // this.my_var = this.$refs.winner_video_loaded.poster = "https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png";
    },
    stop_video() {
      this.$refs.winner_video_loaded.pause()
    },
  }
}

</script>

<style scoped>

.red_button {
  background-color: red;
  color: white;
}



/*https://developer.mozilla.org/en-US/docs/Learn/Tools_and_testing/Client-side_JavaScript_frameworks/Vue_styling*/

.custom-checkbox > .checkbox-label {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 400;
  font-size: 16px;
  font-size: 1rem;
  line-height: 1.25;
  color: #0b0c0c;
  display: block;
  margin-bottom: 5px;
}
.custom-checkbox > .checkbox {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 400;
  font-size: 16px;
  font-size: 1rem;
  line-height: 1.25;
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  height: 2.5rem;
  margin-top: 0;
  padding: 5px;
  border: 2px solid #0b0c0c;
  border-radius: 0;
  appearance: none;
}
.custom-checkbox > input:focus {
  outline: 3px dashed #fd0;
  outline-offset: 0;
  box-shadow: inset 0 0 0 2px;
}
.custom-checkbox {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-weight: 400;
  font-size: 1.6rem;
  line-height: 1.25;
  display: block;
  position: relative;
  min-height: 40px;
  margin-bottom: 10px;
  padding-left: 40px;
  clear: left;
}
.custom-checkbox > input[type="checkbox"] {
  -webkit-font-smoothing: antialiased;
  cursor: pointer;
  position: absolute;
  z-index: 1;
  top: -2px;
  left: -2px;
  width: 44px;
  height: 44px;
  margin: 0;
  opacity: 0;
}
.custom-checkbox > .checkbox-label {
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
  display: inline-block;
  margin-bottom: 0;
  padding: 8px 15px 5px;
  cursor: pointer;
  touch-action: manipulation;
}
.custom-checkbox > label::before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
  border: 2px solid currentcolor;
  background: transparent;
}
.custom-checkbox > input[type="checkbox"]:focus + label::before {
  border-width: 4px;
  outline: 3px dashed #228bec;
}
.custom-checkbox > label::after {
  box-sizing: content-box;
  content: "";
  position: absolute;
  top: 11px;
  left: 9px;
  width: 18px;
  height: 7px;
  transform: rotate(-45deg);
  border: solid;
  border-width: 0 0 5px 5px;
  border-top-color: transparent;
  opacity: 0;
  background: transparent;
}
.custom-checkbox > input[type="checkbox"]:checked + label::after {
  opacity: 1;
}
@media only screen and (min-width: 40rem) {
  label,
  input,
  .custom-checkbox {
    font-size: 19px;
    font-size: 1.9rem;
    line-height: 1.31579;
  }
}


</style>

